import { forwardRef, useMemo } from 'react';

import { Box } from '@chakra-ui/react';

import isNil from 'lodash/isNil';

import { AutocompleteConfig, defaultAutocompleteConfig } from './autocomplete.config';
import { AutocompleteBaseItem } from './autocomplete-base-item';
import { AutocompleteItemProps } from './autocomplete-item.props';

import { wordPluralisation } from '../../../helpers/words-pluralisation';

export const AutocompleteLocationItem = forwardRef<HTMLLIElement, AutocompleteItemProps>(
    ({ itemCount, translationData, ...rest }: AutocompleteItemProps, ref): JSX.Element => {
        const translations: AutocompleteConfig['translationData'] = {
            ...defaultAutocompleteConfig.translationData,
            ...translationData,
        };

        const countLabel = useMemo(() => {
            return typeof itemCount === 'number' && !isNil(itemCount)
                ? wordPluralisation(
                      itemCount,
                      translations.accommodationCount.singular,
                      translations.accommodationCount.plural,
                      translations.accommodationCount.genitivePlural,
                  )
                : null;
        }, [itemCount]);

        return (
            <AutocompleteBaseItem ref={ref} {...rest}>
                {!isNil(itemCount) ? (
                    <Box
                        data-testid={'autocomplete-item-count'}
                    >{`${itemCount} ${countLabel}`}</Box>
                ) : null}
            </AutocompleteBaseItem>
        );
    },
);

AutocompleteLocationItem.displayName = 'AutocompleteLocationItem';
